import { VehicleSocketParametersDto } from '@fleet-beat/api';

export interface SocketResponseDto<T> {
  data: T;
  meta: {
    chanel: string;
    event: string;
    type: SocketEventType;
  };
}

export enum SocketEventType {
  TruckEcu = 'truck-ecu',
  TruckEnvironment = 'truck-environment',
  TruckLocation = 'truck-location',
  TruckTpms = 'truck-tpms',
}

export interface SocketTruckDto {
  truckId: string;
  companyId: string;
  parameters: VehicleSocketParametersDto;
}

export interface SocketDeviceDto {
  deviceId: string;
  companyId: string;
  parameters: VehicleSocketParametersDto;
}
